import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-427725d0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "AppExpectations"
};
var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div style=\"max-width:100vw;position:absolute;top:0px;left:0px;\" data-v-427725d0><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"100vw\" height=\"auto\" viewBox=\"0 0 413 68\" fill=\"none\" data-v-427725d0><path d=\"M264.485 27.6455C354.892 20.6062 389.665 32.6292 413 44.5L413 -0.00012207L0 -0.000120029L0 65C95.007 77.9608 151.477 36.4445 264.485 27.6455Z\" fill=\"white\" fill-opacity=\"0.08\" data-v-427725d0></path></svg></div><div style=\"margin-top:18px;\" data-v-427725d0><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"56\" height=\"56\" viewBox=\"0 0 56 56\" fill=\"none\" data-v-427725d0><g filter=\"url(#filter0_d_22_948)\" data-v-427725d0><path d=\"M28 0C14.7419 0 4 10.7419 4 24C4 37.2581 14.7419 48 28 48C41.2581 48 52 37.2581 52 24C52 10.7419 41.2581 0 28 0ZM28 9.29032C32.7032 9.29032 36.5161 13.1032 36.5161 17.8065C36.5161 22.5097 32.7032 26.3226 28 26.3226C23.2968 26.3226 19.4839 22.5097 19.4839 17.8065C19.4839 13.1032 23.2968 9.29032 28 9.29032ZM28 42.5806C22.3194 42.5806 17.229 40.0065 13.8226 35.9806C15.6419 32.5548 19.2032 30.1935 23.3548 30.1935C23.5871 30.1935 23.8194 30.2323 24.0419 30.3C25.3 30.7065 26.6161 30.9677 28 30.9677C29.3839 30.9677 30.7097 30.7065 31.9581 30.3C32.1806 30.2323 32.4129 30.1935 32.6452 30.1935C36.7968 30.1935 40.3581 32.5548 42.1774 35.9806C38.771 40.0065 33.6806 42.5806 28 42.5806Z\" fill=\"white\" data-v-427725d0></path></g><defs data-v-427725d0><filter id=\"filter0_d_22_948\" x=\"0\" y=\"0\" width=\"56\" height=\"56\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\" data-v-427725d0><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\" data-v-427725d0></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\" data-v-427725d0></feColorMatrix><feOffset dy=\"4\" data-v-427725d0></feOffset><feGaussianBlur stdDeviation=\"2\" data-v-427725d0></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\" data-v-427725d0></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0\" data-v-427725d0></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_22_948\" data-v-427725d0></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_22_948\" result=\"shape\" data-v-427725d0></feBlend></filter></defs></svg></div>", 2);
var _hoisted_4 = {
  style: {
    "color": "rgb(255, 255, 255)",
    "font-family": "'Nunito Sans'",
    "font-size": "23px",
    "font-style": "normal",
    "font-weight": "700",
    "line-height": "normal",
    "max-width": "385px !important",
    "text-align": "left",
    "width": "100vw",
    "display": "block"
  }
};
var _hoisted_5 = {
  style: {
    "border-radius": "17px",
    "border": "1px solid rgba(255, 255, 255, 0.46)",
    "background": "rgba(255, 255, 255, 0.26)",
    "box-shadow": "7px 5px 10.7px 0px rgba(0, 0, 0, 0.25)",
    "color": "#FFF",
    "text-align": "center",
    "text-shadow": "0px 4px 4px rgba(0, 0, 0, 0.25)",
    "font-family": "'Nunito Sans'",
    "font-size": "24px",
    "font-style": "normal",
    "font-weight": "300",
    "padding": "10px",
    "line-height": "normal"
  }
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#FFF",
      "text-align": "center",
      "text-shadow": "7px -2px 4px rgba(0, 0, 0, 0.25)",
      "font-family": "'Nunito Sans'",
      "font-size": "32px",
      "font-style": "normal",
      "font-weight": "700",
      "margin-top": "30px",
      "line-height": "27px"
    }
  }, " App Expectations ", -1);
});
var _hoisted_7 = {
  style: {
    "border-radius": "26px",
    "width": "357px",
    "height": "541px",
    "flex-shrink": "0",
    "margin": "0 auto",
    "margin-top": "20px",
    "background": "rgba(255, 255, 255, 0.88)"
  }
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#000",
      "text-align": "center",
      "margin-top": "35px",
      "font-family": "'Nunito Sans'",
      "font-size": "24px",
      "font-style": "normal",
      "font-weight": "700",
      "line-height": "normal"
    }
  }, [/*#__PURE__*/_createTextVNode("Mark "), /*#__PURE__*/_createElementVNode("u", null, [/*#__PURE__*/_createElementVNode("i", null, "ALL")]), /*#__PURE__*/_createTextVNode(" that "), /*#__PURE__*/_createElementVNode("u", null, [/*#__PURE__*/_createElementVNode("i", null, "may")]), /*#__PURE__*/_createTextVNode(" apply")], -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "color": "#000",
      "font-family": "'Nunito Sans'",
      "font-size": "17px",
      "font-style": "italic",
      "font-weight": "400",
      "text-align": "center",
      "width": "100%",
      "line-height": "normal"
    }
  }, [/*#__PURE__*/_createTextVNode("Your choices "), /*#__PURE__*/_createElementVNode("u", null, [/*#__PURE__*/_createElementVNode("i", null, "change app experiences")])], -1);
});
var _hoisted_10 = {
  "class": "button_group"
};
var _hoisted_11 = {
  key: 0,
  "class": "button__icon"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "29",
    height: "22",
    viewBox: "0 0 29 22",
    fill: "none"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M9.84969 21.5679L0.424678 11.9798C-0.141559 11.4037 -0.141559 10.4697 0.424678 9.89365L2.47524 7.80753C3.04148 7.23144 3.95962 7.23144 4.52586 7.80753L10.875 14.2665L24.4741 0.432029C25.0404 -0.14401 25.9585 -0.14401 26.5248 0.432029L28.5753 2.51814C29.1416 3.09418 29.1416 4.02816 28.5753 4.60426L11.9003 21.568C11.334 22.144 10.4159 22.144 9.84969 21.5679Z",
    fill: "white"
  })], -1);
});
var _hoisted_13 = [_hoisted_12];
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "plus18"
  }, "18+", -1);
});
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "sublabel"
  }, " Necessary for spicy conversations ", -1);
});
var _hoisted_16 = {
  key: 0,
  "class": "button__icon"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "29",
    height: "22",
    viewBox: "0 0 29 22",
    fill: "none"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M9.84969 21.5679L0.424678 11.9798C-0.141559 11.4037 -0.141559 10.4697 0.424678 9.89365L2.47524 7.80753C3.04148 7.23144 3.95962 7.23144 4.52586 7.80753L10.875 14.2665L24.4741 0.432029C25.0404 -0.14401 25.9585 -0.14401 26.5248 0.432029L28.5753 2.51814C29.1416 3.09418 29.1416 4.02816 28.5753 4.60426L11.9003 21.568C11.334 22.144 10.4159 22.144 9.84969 21.5679Z",
    fill: "white"
  })], -1);
});
var _hoisted_18 = [_hoisted_17];
var _hoisted_19 = {
  key: 0,
  "class": "button__icon"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "29",
    height: "22",
    viewBox: "0 0 29 22",
    fill: "none"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M9.84969 21.5679L0.424678 11.9798C-0.141559 11.4037 -0.141559 10.4697 0.424678 9.89365L2.47524 7.80753C3.04148 7.23144 3.95962 7.23144 4.52586 7.80753L10.875 14.2665L24.4741 0.432029C25.0404 -0.14401 25.9585 -0.14401 26.5248 0.432029L28.5753 2.51814C29.1416 3.09418 29.1416 4.02816 28.5753 4.60426L11.9003 21.568C11.334 22.144 10.4159 22.144 9.84969 21.5679Z",
    fill: "white"
  })], -1);
});
var _hoisted_21 = [_hoisted_20];
var _hoisted_22 = {
  key: 0,
  "class": "button__icon"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "29",
    height: "22",
    viewBox: "0 0 29 22",
    fill: "none"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M9.84969 21.5679L0.424678 11.9798C-0.141559 11.4037 -0.141559 10.4697 0.424678 9.89365L2.47524 7.80753C3.04148 7.23144 3.95962 7.23144 4.52586 7.80753L10.875 14.2665L24.4741 0.432029C25.0404 -0.14401 25.9585 -0.14401 26.5248 0.432029L28.5753 2.51814C29.1416 3.09418 29.1416 4.02816 28.5753 4.60426L11.9003 21.568C11.334 22.144 10.4159 22.144 9.84969 21.5679Z",
    fill: "white"
  })], -1);
});
var _hoisted_24 = [_hoisted_23];
var _hoisted_25 = {
  key: 0,
  "class": "button__icon"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "29",
    height: "22",
    viewBox: "0 0 29 22",
    fill: "none"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M9.84969 21.5679L0.424678 11.9798C-0.141559 11.4037 -0.141559 10.4697 0.424678 9.89365L2.47524 7.80753C3.04148 7.23144 3.95962 7.23144 4.52586 7.80753L10.875 14.2665L24.4741 0.432029C25.0404 -0.14401 25.9585 -0.14401 26.5248 0.432029L28.5753 2.51814C29.1416 3.09418 29.1416 4.02816 28.5753 4.60426L11.9003 21.568C11.334 22.144 10.4159 22.144 9.84969 21.5679Z",
    fill: "white"
  })], -1);
});
var _hoisted_27 = [_hoisted_26];
var _hoisted_28 = {
  "class": "warning__Label"
};
var _hoisted_29 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$store.state.preventIntroExperience ? 'New App Version Released' : 'Whoo Hoo!'), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$store.state.preventIntroExperience ? 'Let\'s Make Updates To Your Profile' : 'Now, Let\'s Get Your Account Setup'), 1), _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
    "class": _normalizeClass({
      'button': true,
      'button--selected': $data.romantic
    }),
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.romantic = !$data.romantic;
    })
  }, [$data.romantic ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13)) : _createCommentVNode("", true), _createTextVNode(" Romantic / Sexual / X-rated "), _hoisted_14, _hoisted_15], 2), _createElementVNode("button", {
    "class": _normalizeClass({
      'button': true,
      'button--selected': $data.tool
    }),
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $data.tool = !$data.tool;
    })
  }, [$data.tool ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18)) : _createCommentVNode("", true), _createTextVNode(" A useful tool ")], 2), _createElementVNode("button", {
    "class": _normalizeClass({
      'button': true,
      'button--selected': $data.assistant
    }),
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $data.assistant = !$data.assistant;
    })
  }, [$data.assistant ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)) : _createCommentVNode("", true), _createTextVNode(" As a Personal Assistant ")], 2), _createElementVNode("button", {
    "class": _normalizeClass({
      'button': true,
      'button--selected': $data.code
    }),
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $data.code = !$data.code;
    })
  }, [$data.code ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24)) : _createCommentVNode("", true), _createTextVNode(" Code Assistant ")], 2), _createElementVNode("button", {
    "class": _normalizeClass({
      'button': true,
      'button--selected': $data.information
    }),
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $data.information = !$data.information;
    })
  }, [$data.information ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)) : _createCommentVNode("", true), _createTextVNode(" Data or Information Purposes ")], 2), _createElementVNode("div", _hoisted_28, [$data.romantic ? (_openBlock(), _createElementBlock("div", _hoisted_29, " By Continuing you agree you're above the age of 18 years old")) : _createCommentVNode("", true)]), _createElementVNode("button", {
    "class": _normalizeClass({
      'button': true,
      'button--secondary': true,
      'button--disabled': !$data.romantic && !$data.tool && !$data.assistant && !$data.code && !$data.information
    }),
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return $options.nextPage();
    })
  }, _toDisplayString(!$data.romantic && !$data.tool && !$data.assistant && !$data.code && !$data.information ? 'Awaiting Selection' : 'Continue'), 3)])])]);
}